<template>
	<div class="contact-us__wrap">
		<div class="contact-us__title">Contact US</div>
		<form @submit.prevent="subscribe" class="thrive__form" :class="processingClass">
			<div class="thrive__form__group">
				<div class="thrive__form__item" :class="{'thrive__form__item__invalid': $v.name.$error}">
					<input class="thrive__form__input" type="text" placeholder="NAME" v-model="name"
					       :class="inputStatus($v, 'name')" :disabled="isFormPending">
					<ul class="thrive__form__item__errors" v-if="$v.name.$error">
						<li v-if="!$v.name.required">This field is required</li>
					</ul>
					<form-error :field-name="'name'"></form-error>
				</div>
				<div class="thrive__form__item" :class="{'thrive__form__item__invalid': $v.email.$error}">
					<input class="thrive__form__input" type="text" placeholder="E-MAIL" v-model="email"
					       :class="inputStatus($v, 'email')" :disabled="isFormPending">
					<ul class="thrive__form__item__errors" v-if="$v.email.$error">
						<li v-if="!$v.email.required">This field is required</li>
						<li v-if="!$v.email.email">Email should be valid</li>
					</ul>
					<form-error :field-name="'email'"></form-error>
				</div>
				<div class="thrive__form__item thrive__form__submit-wrap desc-btn">
					<button class="thrive__form__submit btn" type="submit" :disabled="isFormPending">Submit</button>
				</div>
			</div>
			<div class="thrive__form__group">
				<div class="thrive__form__item thrive__form__textarea-wrap" :class="{'thrive__form__item__invalid': $v.message.$error}">
					<textarea class="thrive__form__input thrive__form__textarea" placeholder="MESSAGE"
					          v-model="message" :class="inputStatus($v, 'message')"
					          :disabled="isFormPending"></textarea>
					<ul class="thrive__form__item__errors" v-if="$v.message.$error">
						<li v-if="!$v.message.required">This field is required</li>
					</ul>
					<form-error :field-name="'message'"></form-error>
                    <button class="thrive__form__submit btn mob-btn" type="submit" :disabled="isFormPending">Submit</button>
				</div>
			</div>
		</form>
        <vue-recaptcha
            ref="recaptcha"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
            size="invisible"
            :sitekey="recaptchaSiteKey"
        ></vue-recaptcha>
	</div>
</template>

<script>
	const { required, email } = require('vuelidate/lib/validators');
	import { validationMixin } from 'vuelidate';
	import VueRecaptcha from 'vue-recaptcha';

	export default {
		name: "contact-us",
		mixins: [validationMixin],
		props: ['routeContact', 'recaptchaSiteKey'],
		components: { VueRecaptcha },
		data() {
			return {
				email: '',
				name: '',
				message: ''
			}
		},
		methods: {
			subscribe() {
				this.$v.$touch();
				if (!this.$v.$invalid) {
					this.$refs.recaptcha.execute();
				}
			},
			async onCaptchaVerified(recaptchaToken) {
				const self = this;
				this.isFormPending = true;
				this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
				await axios.post(this.routeContact, {
					email: self.email,
					name: self.name,
					message: self.message,
					recaptchaToken: recaptchaToken
				})
					.then(response => {
						if(response.data) {
							self.$toasted.success(`&nbsp;${response.data.status}`, {});
							self.email = '';
							self.name = '';
							self.message = '';
							this.$v.$reset();
						}
					})
					.catch(() => {})
					.finally(() => { self.isFormPending=false; self.$refs.recaptcha.reset(); });
			},
			onCaptchaExpired() {
				this.$refs.recaptcha.reset();
			}
		},
		computed: {
			processingClass() {
				return {
					'processing': this.isFormPending
				}
			}
		},
		validations() {
			let v = {};
			v.email = {
				required,
				email
			};
			v.name = {
				required
			};
			v.message = {
				required
			};
			return v;
		}
	}
</script>



// WEBPACK FOOTER //
// resources/js/components/contact-us.vue